<template>
  <div style="width: 100%; display: flex; justify-content: space-between;">
    <span v-for="(key) in keys" style="width: 14.2%;">
       <i :class="{'fas fa-square': city.nameInfo[key], 'far fa-square': !city.nameInfo[key]}"
          style="width: 11px"
          :tooltip="city.nameInfo[key]"
          :title="city.nameInfo[key]"/>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keys: [
        "nominative",
        "genitive",
        "dative",
        "accusative",
        "ablative",
        "prepositional",
        "short"
      ]
    }
  },
  props: {
    city: {
      required: true
    },
  },
  components: {
  },
  created() {
  },
  methods: {
  },
  computed: {
  }
}
</script>
<style>
</style>
